import { z } from "zod";

export const CredentialStatus = {
	IN_PROGRESS: "In Progress",
	PASS: "Pass",
	FAIL: "Fail",
	DROP: "Drop",
} as const;

export type CredentialStatus = (typeof CredentialStatus)[keyof typeof CredentialStatus];

export const CREDENTIAL_STATUSES = Object.values(CredentialStatus) as readonly CredentialStatus[];

export const credentialStatusSchema = z.enum(CredentialStatus);
